
export default function ContactInfo() {
  const info = [
    {
      icon: "ri-time-line",
      title: "Horario de Apertura",
      content: "Lun-Vie: 09:00-14:00",
    },
    {
      icon: "ri-map-pin-line",
      title: "Cómo llegar a Quereda y Murcia desde:",
      links: [
        {
          text: "Catedral de Murcia",
          // URL corrected – removed stray quotes and ensured a proper string
          url: "https://www.google.es/maps/dir/Catedral+de+Murcia,+Palacio+Episcopal,+Plaza+del+Cardenal+Belluga,+Murcia/@37.9851128,-1.1316052,17z/data=!3m2!4b1!5s0xd63821b01fc84cd:0x6f43f3f33895365!4m14!4m13!1m5!1m1!1s0xd63821b3435ac97:0xae905eadb07c3969!2m2!1d-1.1285752!2d37.9840473!1m5!1m1!1s0xd63832269dee675:0x29f4ec99648b8f3c!2m2!1d-1.1283501!2d37.9859561!3e2?entry=ttu",
        },
        {
          text: "Ayuntamiento de Murcia",
          url: "https://www.google.es/maps/dir/Ayuntamiento+de+Murcia,+Glorieta+de+Espa%C3%B1a,+Murcia/@37.9842597,-1.1311596,17z/data=!3m2!4b1!5s0xd63821b01fc84cd:0x6f43f3f33895365!4m14!4m13!1m5!1m1!1s0xd63821d088134a5:0xcdfa1add0c0b42a5!2m2!1d-1.1302896!2d37.9834145!1m5!1m1!1s0xd63832269dee675:0x29f4ec99648b8f3c!2m2!1d-1.1283501!2d37.9859561!3e0?entry=ttu",
        },
        {
          text: "Teatro Romea",
          url: "https://www.google.es/maps/dir/Teatro+Romea,+Plaza+Juli%C3%A1n+Romea,+Murcia/@37.9865148,-1.1320468,17z/data=!3m2!4b1!5s0xd63821b01fc84cd:0x6f43f3f33895365!4m14!4m13!1m5!1m1!1s0xd63821c78fc89e7:0xc80ce1cd329d4861!2m2!1d-1.1305832!2d37.9870604!1m5!1m1!1s0xd63832269dee675:0x29f4ec99648b8f3c!2m2!1d-1.1283501!2d37.9859561!3e2?entry=ttu",
        },
      ],
    },
    {
      icon: "ri-car-line",
      title: "Como ir en coche",
      content: "Coordenadas GPS",
      gps: "37.98614210483484, -1.1283501030867895",
    },
  ];

  return (
    <section id="contacto" className="py-20 bg-[#E8F4F8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {info.map((item, index) => (
            <div key={index} className="text-center">
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 bg-[#A77047] rounded-full flex items-center justify-center">
                  <i className={`${item.icon} text-3xl text-white`}></i>
                </div>
              </div>
              <h3 className="text-lg font-bold text-[#2C3E50] mb-3">{item.title}</h3>

              {item.content && (
                <p className="text-[#2C3E50] text-sm mb-2">{item.content}</p>
              )}

              {item.gps && (
                <p className="text-[#A77047] text-sm font-medium">{item.gps}</p>
              )}

              {item.links && (
                <div className="space-y-2">
                  {item.links.map((link, linkIndex) => (
                    <a
                      key={linkIndex}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-[#2C3E50] hover:text-[#A77047] text-sm transition-colors cursor-pointer"
                    >
                      {link.text}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
